import {
	ADMINLOYALTYPOINTOPERATION_SUCCESS,
	ADMINLOYALTYPOINTOPERATION_FAILED,
	RESET_ADMINLOYALTYPOINTOPERATION,
	LOADING_ADMINLOYALTYPOINTOPERATION,
	NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAdminLoyaltyPointOperation = () => {
	return { type: RESET_ADMINLOYALTYPOINTOPERATION };
};

const adminLoyaltyPointOperation =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINLOYALTYPOINTOPERATION });
		await partnerServices
			.post("gateLoyaltyPointOperationsList", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminLoyaltyPointOperationsuccess(res.data));
						break;
					default:
						dispatch(adminLoyaltyPointOperationFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION,
					payload: err
				});
			});
	};
function adminLoyaltyPointOperationsuccess(data) {
	return {
		type: ADMINLOYALTYPOINTOPERATION_SUCCESS,
		payload: data
	};
}
function adminLoyaltyPointOperationFailed(data) {
	return {
		type: ADMINLOYALTYPOINTOPERATION_FAILED,
		payload: data
	};
}

export { resetAdminLoyaltyPointOperation, adminLoyaltyPointOperation };
